<template>
    <div class="alert-box">
        <div class="alert-box__icon">
            <img src="/images/icons/info-outline.svg" />
        </div>

        <div class="alert-box__text">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {

}
</script>
